// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"be911fbe","608":"45bf65de","716":"28876953","775":"6b52ee3a","868":"28961b6b"}[chunkId] + ".chunk.js";
};